import { useState } from "react";
import { FileText, Download, Eye, X } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { fileUrl } from "@/lib/api";
import { EXPECTED_DOCS, RECEPISSES } from "@/lib/content";
import { PageHero } from "@/components/kit";
import { MemberGrid, useFetch } from "@/components/shared";

const NAME = { ong: "ONG MA LEBA", association: "ASSOCIATION MA LEBA" };

export function Bureau({ universe }) {
  useSeo(`Bureau exécutif — ${NAME[universe]}`, `Membres du bureau exécutif de l'${NAME[universe]}.`);
  const members = useFetch(`/members?structure=${universe}`, [universe]);
  return (
    <div data-testid={`bureau-page-${universe}`}>
      <PageHero eyebrow={NAME[universe]} title="Bureau exécutif" intro="Les femmes et les hommes qui portent nos actions." />
      <section className="pagne py-14"><div className="container-x"><MemberGrid members={members} /></div></section>
    </div>
  );
}

export function Documents({ universe }) {
  useSeo(`Documents officiels — ${NAME[universe]}`, `Statuts et règlement intérieur de l'${NAME[universe]} en PDF.`);
  const docs = useFetch(`/documents?structure=${universe}`, [universe]);
  const [view, setView] = useState(null);
  return (
    <div data-testid={`documents-page-${universe}`}>
      <PageHero eyebrow={NAME[universe]} title="Documents officiels" intro={RECEPISSES[universe]} />
      <section className="container-x max-w-4xl space-y-4 py-14">
        {(docs || []).map((d, i) => (
          <div key={d.id} className="card flex flex-col gap-4 p-5 sm:flex-row sm:items-center" data-testid={`document-item-${i}`}>
            <FileText className="h-10 w-10 shrink-0 text-u" aria-hidden="true" />
            <div className="flex-1">
              <p className="font-display text-xl font-bold uppercase text-ink">{d.title}</p>
              <p className="text-sm text-neutral-600">{d.doc_type}{d.description && ` — ${d.description}`}</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setView(d)} className="btn-outline !px-4 !py-2 text-u" data-testid={`document-view-${i}`}><Eye className="h-4 w-4" /> Consulter</button>
              <a href={fileUrl(d.url)} download target="_blank" rel="noopener noreferrer" className="btn-u !px-4 !py-2" data-testid={`document-download-${i}`}><Download className="h-4 w-4" /> PDF</a>
            </div>
          </div>
        ))}
        {docs && !docs.length &&
          EXPECTED_DOCS[universe].map((t) => (
            <div key={t} className="card flex items-center gap-4 border-dashed p-5 opacity-80" data-testid="document-pending">
              <FileText className="h-10 w-10 text-neutral-400" aria-hidden="true" />
              <div><p className="font-display text-xl font-bold uppercase text-ink">{t}</p><p className="text-sm text-neutral-500">Document bientôt disponible en téléchargement.</p></div>
            </div>
          ))}
      </section>
      {view && (
        <div className="fixed inset-0 z-[60] flex flex-col bg-black/85 p-3 sm:p-8" role="dialog" aria-modal="true" aria-label={view.title} data-testid="document-viewer">
          <div className="mb-2 flex items-center justify-between text-white">
            <p className="font-display text-lg uppercase">{view.title}</p>
            <button onClick={() => setView(null)} aria-label="Fermer" className="rounded-full bg-white/10 p-2" data-testid="document-viewer-close"><X className="h-5 w-5" /></button>
          </div>
          <iframe title={view.title} src={fileUrl(view.url)} className="w-full flex-1 rounded bg-white" />
        </div>
      )}
    </div>
  );
}
